/** Limite de upload na jornada do cliente (aviso de sinistro). */
export const AVISO_SINISTRO_MAX_FILE_SIZE_BYTES = 100 * 1024 * 1024;

/** Rótulo exibido em telas e mensagens de erro. */
export const AVISO_SINISTRO_MAX_FILE_SIZE_LABEL = '100MB';
